module.exports = __webpack_public_path__ + "img/m-banner-cjizfoaj-th-TH.9a4e7051.png";